/**
 * Copyright 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { When } from "react-if";
import { BrickLoader, LoadMore } from "@nordcloud/gnui";
import {
  EventDetailResourceFragment,
  EventDetailResourceGroupFragment,
  IncomingEventStatus,
} from "~/generated/graphql";
import { ResourceList } from "~/components/resourceGroup/ResourceList";
import { usePaginatedActionResources } from "~/views/resourceGroups/hooks/";

type Props = {
  resourceGroups: EventDetailResourceGroupFragment[];
  resources: EventDetailResourceFragment[];
  status?: IncomingEventStatus;
};

export function IncomingEventResourcesSection({
  resourceGroups,
  resources,
  status,
}: Props) {
  const {
    loading,
    hasPagination,
    visibleResourceGroups,
    visibleResources,
    loadMoreProps,
  } = usePaginatedActionResources(resourceGroups, resources);

  if (loading) {
    return <BrickLoader height="14rem" />;
  }

  return (
    <>
      <ResourceList
        resourceGroups={visibleResourceGroups}
        resources={visibleResources}
        status={status}
      />
      <When condition={hasPagination}>
        <LoadMore {...loadMoreProps} />
      </When>
    </>
  );
}
